import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../reducers/store';
import { Link, useLocation } from 'react-router-dom';
import moment from 'moment'
import toast from 'react-hot-toast';
import { StatePostParams } from '../../../types/posts/postParams';
import { actionDeletePost, actionFetchPosts } from '../../../actions/posts';
import { AddRounded, CloseRounded, DeleteRounded, DoNotDisturbAltRounded, EditRounded } from '@mui/icons-material';
import { Button, ImageBuffer, Loader, PageHeader, Pagination } from '../../../components';
import { PostsListHeader } from '../../../utils/constants';
import { emptyDisplay, posts } from '../../../assets';

import './viewPosts.css'

interface DeletePostParams {
  id: string;
  title: string;
}

const ViewPosts = () => {
  const dispatch                                              = useDispatch<AppDispatch>();
  const location                                              = useLocation();
  const searchParams                                          = new URLSearchParams(location.search);
  const page                                                  = searchParams.get("page") || 1
  const {isLoading, getAllPosts, numberOfPages, totalNumber}  = useSelector((state: RootState) => state.postList);
  const [allPosts, setAllPosts]                               = useState<StatePostParams[]>(getAllPosts);
  const [isOpen, setIsOpen]                                   = useState<{ [key: number]: boolean }>({})
  // const [page, setPage]                                    = useState<number>(1);
  
  const handleClick = (index: number) => () => {
    setIsOpen(prev => ({ [index]: !prev[index]}))
  }
  
  const handleDeletePost = ({id, title}: DeletePostParams) => {
    if (window.confirm(`Are you sure you want to delete this user ${title}?`)) {
      // Dispatch the deletePost action here
      dispatch(actionDeletePost({id}))
        .then(() => {
          setAllPosts(allPosts.filter(post => post._id !== id));
          // Show success toast after successfully deleting the post
          toast.success('User deleted successfully');
        })
        .catch((error) => {
          // Handle any errors that occur during the deletion process
          toast.error('Error deleting post: ' + error.message);
        });
    }
  };
  
  useEffect(() => {
    dispatch(actionFetchPosts({page})); // You can pass the page number as needed
  }, [dispatch, page]);

  if(!allPosts?.length && !isLoading) return (
    <>
      <div className='empty-profile-card-wrapper'>
        <div className='empty-profile-card-header'>
          <span><DoNotDisturbAltRounded /></span>
          <h1> No Post Found </h1>
        </div>
        <Button buttonWrapper="button-wrapper" linkButton linkTo="/posts/create-posts" linkClass="link-wrapper" linkName="create post" />
      </div>
    </>
  )

  return (
    <>
      <title>Posts</title>
      <PageHeader title="Posts" description="Welcome to the Posts" download="Download Report" />
      <div className='table-main-wrapper'>
        <div className='table-header'>
          <h3>Posts</h3>
          <Button buttonWrapper="button-wrapper" linkButton linkTo="/posts/create-posts" linkClass="link-wrapper" linkName="create post" />
        </div>
        {isLoading ? <Loader /> : (
          <table className='main-table'>
            <thead>
              <tr>
                {PostsListHeader.map((option, index) => (
                  <th key={index}>{option.name}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {allPosts?.map((detail, index) => {
              const postImage = `${process.env.REACT_APP_BACKEND_POSTS_IMAGE_URL}${detail?.selectedFile}` || emptyDisplay;

              return(
                <tr key={index}>
                  <td data-cell="image">
                    <div className="table-image">
                      {isLoading ? <Loader /> : (
                        <ImageBuffer src={postImage} alt='post image'/>
                      )}
                    </div>
                  </td>
                  <td data-cell="title">{detail.title}</td>
                  <td data-cell="description">{detail.description}</td>
                  <td data-cell="category">{detail.category}</td>
                  <td data-cell="link">{detail.link}</td>
                  <td data-cell="created">{moment(detail.createdAt).format('YYYY-MM-DD')}</td>
                  <td data-cell="edit">
                    <div  className={isOpen[index] ? 'button-option active' : 'button-option'}>
                      <button className='button-option-head' onClick={handleClick(index)}>{isOpen[index] ? (<span><CloseRounded /></span>) : (<span><AddRounded /></span>)}</button>
                      <div className='button-menu-option'>
                        <Link to={`/posts/edit-post/${detail._id}`} className='button-menu-detail'>
                          <EditRounded />
                          <span>Edit post</span>
                        </Link>
                        <button className='button-menu-detail' onClick={() => handleDeletePost({ id: detail._id, title: detail.title }) }>
                          <DeleteRounded />
                          <span>Delete</span>
                        </button>
                      </div>
                    </div>
                  </td>
                </tr>
              )})}
            </tbody>
          </table>
        )}
        <Pagination actionGet={actionFetchPosts} page={page} numberOfPages={numberOfPages} totalNumber={totalNumber} />
      </div>
    </>
  )
}

export default ViewPosts